import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-search-highlights',
    templateUrl: './search-highlights.component.html',
    styleUrls: ['./search-highlights.component.scss'],
    standalone: false
})
export class SearchHighlightsComponent implements OnInit {

  mapping =[
    {
      "key":"Relevant Skills"
    },
    {
      "key":"Likely To Move"
    },
    {
      "key":"Loyalty"
    },
    {
      "key":"In High Demand"
    }
  ]
  constructor() { }

  ngOnInit() {
  }

}
